import React from "react";
import {
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import {
  installSentryEventScrubber,
  posthogPrivacyOptions,
  replayPrivacyOptions,
  sentryPrivacyOptions,
} from "./utils/telemetryScrub";

// Both SDKs start before the app strips auth tokens from the URL, so every
// payload is scrubbed (see utils/telemetryScrub.js).
Sentry.init({
  dsn: "https://bd4c2c313aca68002750b1c7064780c6@o4511729993973760.ingest.us.sentry.io/4511730000396288",
  dataCollection: {},
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(replayPrivacyOptions),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  ...sentryPrivacyOptions,
});
installSentryEventScrubber(Sentry);

const posthogToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
if (posthogToken) {
  posthog.init(posthogToken, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: "2026-05-30",
    ...posthogPrivacyOptions,
  });
}

export const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);
export { posthog };
